import { isAfter, isBefore, isValid, parseISO } from 'date-fns';
import { DateString } from '@iss/libs/graphql';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DateFormValidators {
  public static minDate(date: DateString): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const dateToCheck = parseISO(control.value as string);

      if (!isValid(dateToCheck)) return null;

      const minDate = parseISO(date);

      return !isBefore(dateToCheck, minDate)
        ? null
        : { minDate };
    };
  }

  public static maxDate(date: DateString): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const dateToCheck = parseISO(control.value as string);

      if (!isValid(dateToCheck)) return null;

      const maxDate = parseISO(date);

      return !isAfter(dateToCheck, maxDate)
        ? null
        : { maxDate };
    };
  }

}
